Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfo = Greenmile.Task.RelatedInfo || {};

Greenmile.Task.RelatedInfo.Agruped = {

  createFullAgrupedInfo: function (links, index) {
    this.createAgrupedIdNode(links[index]);
  },

  createAgrupedIdNode: function (linkAgruped) {
    const collections = Greenmile.Task.RelatedInfo.collections;

    const findInCollections = (linkKey) => 
      Object.values(collections).find(
        (collection) => collection.model === linkKey
      );

    const makeCollectionsToWork = (collectionsToWork, linkKey) => {
      const linkCollection = findInCollections(linkKey);

      if (linkCollection) {
        collectionsToWork.push(linkCollection);
      }

      return collectionsToWork;
    };

    const collectionsToCreate = Object.keys(linkAgruped).reduce(
      makeCollectionsToWork, []
    );

    this.createIdNodeToEachModel(linkAgruped, collectionsToCreate);
  },

  createIdNodeToEachModel: function (linkAgruped, collectionsToCreate) {
    const linkedWhen = document.createElement('input');
    const data = linkAgruped;

    collectionsToCreate.forEach(collection => {
      const model = collection.model;
      const modelId = data[model].id;
      const modelContainer = document.createElement('div');
      const divDel = document.createElement('div');
      const divDestroy = document.createElement('div');
      const inputsNamesPrefix = `taskLinkeds['${modelId}']`;

      const inputsToCreate = [
        {
          name: 'input',
          sufix: `${model}.id`,
          value: modelId
        },
        {
          name: 'inputStatus',
          sufix: `status`,
          value: ''
        },
        {
          name: 'inputLinked',
          sufix: `id`,
          value: (data.id || '')
        },
      ];
      
      const modelTitle = this.createModelTitle(data, model);

      modelContainer.id = `${model}_${modelId}`;
      modelContainer.className = `item_lookuplist_${model}_${modelId}`;

      divDel.className = "del_item_added";

      inputsToCreate.forEach(inputData => {
        const inputEl = document.createElement('input');

        inputEl.type = 'hidden';
        inputEl.name = `${inputsNamesPrefix}.${inputData.sufix}`;
        inputEl.id = `${inputsNamesPrefix}.${inputData.sufix}`;
        inputEl.className = "modelAttribute";
        inputEl.value = inputData.value;

        modelContainer.appendChild(inputEl);
        if (inputData.name === 'input') {
          Monet.Session.Task.lastLinkForm.agruped.ids.push(inputEl);
        }
      });

      linkedWhen.type = 'hidden';
      linkedWhen.id = `taskLinkeds[${data.id}].when`;
      linkedWhen.name = `taskLinkeds[${data.id}].when`;
      linkedWhen.className = "modelAttribute";
      linkedWhen.value = data.when || Monet.Format.DateTime.formatToISOString(new Date());

      divDestroy.className = "table-action-destroylink";
      divDestroy.innerHTML = "&nbsp;";

      divDestroy.addEventListener('click', (e) => {
        e.preventDefault();

        const confirmDelete = () => {
          App.Views.Task.showLoadingElement(divDestroy);

          this.executeDeletion(data, model);
        };

        Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmDelete);

      });

      divDel.appendChild(divDestroy);

      modelContainer.appendChild(modelTitle);
      modelContainer.appendChild(divDel);
      modelContainer.appendChild(linkedWhen);

      modelContainer.modelId = modelId;
      modelContainer.agrupedId = data.id;
      Monet.Session.Task.lastLinkForm.agruped.nodes.push(modelContainer);

      const collectionWithModelId = {
        id: modelId,
        agrupedId: data.id,
        ...collection
      };
      Monet.Session.Task.lastLinkForm.agruped.models.push(collectionWithModelId);
    });

    Monet.Session.Task.lastLinkForm.agruped.data.push(data);
  },

  createModelTitle: function (linkAgruped, model) {
    const linkData = linkAgruped[model];
    const collections = Greenmile.Task.RelatedInfo.collections;
    const titleEl = document.createElement('div');

    if (model === collections.EVENTS.model) {

      const descriptionEl = document.createElement('div');
      const dateEl = document.createElement('div');

      titleEl.className = "GreenmileTaskRouteListLine";
      titleEl.id = 'event_list_line_' + linkData.id;

      descriptionEl.className = "GreenmileTaskRouteListCloumn";
      dateEl.className = "GreenmileTaskRouteListCloumn";

      titleEl.appendChild(descriptionEl);
      titleEl.appendChild(dateEl);

    } else if (model === collections.ORDERS.model) {

      titleEl.className = "title_item_added";
      titleEl.appendChild(document.createTextNode(linkData.number));

    } else if (model === collections.SURVEYS.model) {

      titleEl.className = "title_item_added";
      titleEl.appendChild(document.createTextNode(linkData.title));

    } else if (model === collections.ANOTHER_TASK.model) {

      const value = linkData.title || linkData.description;

      titleEl.className = "title_item_added";
      titleEl.innerHTML = value;

    } else if (model === collections.ROUTES.model) {

      const organizationEl = document.createElement('div');
      const keyEl = document.createElement('div');
      const dateEl = document.createElement('div');

      titleEl.className = "GreenmileTaskRouteListLine taskRouteLineItem";

      organizationEl.className = "GreenmileTaskRouteListCloumn organization";
      keyEl.className = "GreenmileTaskRouteListCloumn key";
      dateEl.className = "GreenmileTaskRouteListCloumn date";

      organizationEl.innerHTML = linkData.organization.description;
      keyEl.innerHTML = linkData.key;
      dateEl.innerHTML = Monet.Format.Date.formatToLocale(linkData.date);

      titleEl.appendChild(organizationEl);
      titleEl.appendChild(keyEl);
      titleEl.appendChild(dateEl);
    } else {

      titleEl.className = "title_item_added";
      titleEl.innerHTML = linkData.key;

    }

    return titleEl;
  },

  executeDeletion: function(data, model) {
    const agrupedId = data.id;
    const modelId = data[model].id;

    const getACopyFromAgrupedData = () =>
      JSON.parse(JSON.stringify(Monet.Session.Task.lastLinkForm.agruped.data));
    const selectAgrupedDataById = (agrupedDataToModify) => agrupedDataToModify
      .find(agrupedData => agrupedData.id === agrupedId);
    const deleteModelFrom = (agrupedDataToPersist) =>
      delete agrupedDataToPersist[model];

    const agrupedDataToModify = getACopyFromAgrupedData();
    const agrupedDataToPersist = selectAgrupedDataById(agrupedDataToModify);
    deleteModelFrom(agrupedDataToPersist);

    const updateDomAndDataAfterSucceed = this.prepareSucceed(agrupedDataToPersist, agrupedId, modelId);

    Greenmile.Task.RelatedInfo.removeTaskLinkedAsAgruped(
      agrupedDataToPersist,
      updateDomAndDataAfterSucceed
    );
  },

  prepareSucceed: function (agrupedDataToPersist, agrupedId, modelId) {
    return () => {
      App.Views.Task.hideLoad();
      const { nodes, ids, models, data } = Monet.Session.Task.lastLinkForm.agruped;
      const nodeIndexToRemove = nodes.findIndex(node =>
        (node.agrupedId === agrupedId && node.modelId === modelId)
      );

      const removeItemFromDom = () => {
        const nodeToBeRemoved = nodes[nodeIndexToRemove].parentNode.parentNode;
        const relatedLinksContainer = nodeToBeRemoved.parentNode;
        relatedLinksContainer.removeChild(nodeToBeRemoved);
      };

      const removeItemFromDatas = () => {
        nodes.splice(nodeIndexToRemove, 1);
        ids.splice(nodeIndexToRemove, 1);
        models.splice(nodeIndexToRemove, 1);
      };

      const updateTheAgrupedData = () => {
        const dataIndexToUpdate = data.findIndex(data =>
          data.id === agrupedDataToPersist.id
        );

        data[dataIndexToUpdate] = agrupedDataToPersist;
      };

      removeItemFromDom();
      removeItemFromDatas();
      updateTheAgrupedData();
    }
  },
};
